module.exports = __webpack_public_path__ + "img/yuanjing-black1.bec41e13.png";